import BaseApi from './base/BaseApi';
import { GetOperation } from '@/api/rest/base/operations';

export default class extends BaseApi {
  static entityName = 'project_file_attaches';

  getExtAccessToken(id, withPreloader = true) {
    const operation = new GetOperation(`/api/projects/ext/${id}/token`);
    return this.execute(operation, withPreloader);
  }

  fetchExternal(extId, token, withPreloader = true) {
    const operation = new GetOperation(`/api/projects/ext/attaches/${extId}/${token}`);
    return this.execute(operation, withPreloader);
  }
}
